import type { EmailDesign } from "../email-design/server/supabase-email-design-service";
import {
  type GenericToolbarDropdownElement,
  type GenericToolbarElement,
} from "../message/editor/plugins/generic-toolbar/types";
import type { EmailDesignTemplateSettings } from "../message/editor/types/serialised-editor-design";

export function makeEmailToolbarTopLevelElements(template?: {
  settings?: EmailDesignTemplateSettings;
  onChange: (val: EmailDesignTemplateSettings) => void;
  templateSelectorSettings?: {
    emailDesigns: EmailDesign[];
    selectedEmailDesign?: EmailDesign;
    setEmailDesign: (ed?: EmailDesign) => void;
  };
}): GenericToolbarElement[] {
  const settings = template?.templateSelectorSettings;

  const contentDropdownChildren: GenericToolbarDropdownElement[] = [
    { type: "addImagesAndFiles" },
    { type: "imageButton" },
    { type: "addButton", channel: "work_email" },
    { type: "dynamicContent" } as const,
    { type: "addDivider", channel: "work_email" },
    { type: "columnsButton" },
    { type: "tableButton" },
  ];

  return [
    ...(settings ? [{ type: "emailTemplateSelector", settings } as const] : []),
    { type: "blockFormat" },
    { type: "bold" },
    { type: "italic" },
    { type: "underline" },
    { type: "mergeTagPicker" },
    { type: "linkButton" },
    { type: "emojiPicker" },
    { type: "fontColourSelect" },
    { type: "fontBackgroundColourSelect" },
    ...(template ? [{ type: "paperColourSelect" } as const] : []),
    {
      type: "toolbarDropDown",
      children: contentDropdownChildren,
    },
    { type: "alignmentButtons" },
    { type: "pollButton" },
    { type: "surveyButton", channel: "work_email" } as const,
  ];
}
